export default __webpack_public_path__ + "static/tasks-7a5335060465b02e3eae74af83d56252.png";